import VueTagsInput from '@johmun/vue-tags-input'
import Vue from 'vue'

Vue.use(VueTagsInput)
